export default {
  labels: {
    signed_by: 'Signed by {{name}} on {{date}}',
    signed_by_no_date: 'Signed by {{name}}',
  },
  buttons: {
    retry: 'Try again',
  },
  errors: {
    load_failed: 'The contract could not be loaded. Check your connection and try again.',
  },
};
